import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import TableContainer from '@/components/_common/Table/TableContainer';
import { getProfileCustomers } from '@/redux/slices/constantsSlice';
import { getWorkflows } from '@/redux/slices/profileSlice';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import ProfilesTitleBar from './ProfilesTitleBar';

const Profiles = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('profiles'));
    dispatch(getProfileCustomers());
    dispatch(getWorkflows());
  }, []);

  const onRowClick = (e, item) => {
    const url = `/profiles/${item.id}`;
    // TODO: we're doing this to simulate ctrl+click,
    // but we should be using the proper element for accessibility
    e.ctrlKey || e.metaKey ? window.open(url) : history.push(url);
  };

  return (
    <>
      {currentTableKey === 'profiles' && (
        <>
          <ProfilesTitleBar />
          <DataTableFilters disableExportReport />
          <TableContainer onRowClick={onRowClick} />
        </>
      )}
    </>
  );
};

export default Profiles;
